import React from 'react';
import { SkinSelector } from '../../propertyPanel/CommonProperties/SkinSelector';

/**
 * FixedBgText 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const FixedBgTextProperties = [
  {
    group: '배경 이미지 설정',
    icon: 'image',
    properties: [
      {
        name: 'componentProps.bgImageUrl',
        label: '배경 이미지',
        control: 'ImageUpload',
        defaultValue: 'https://via.placeholder.com/1920x1080'
      }
    ]
  },
  {
    group: '오버레이 설정',
    icon: 'palette',
    properties: [
      {
        name: 'componentProps.overlayColor',
        label: '오버레이 색상',
        control: 'ColorPicker',
        defaultValue: '#000000'
      },
      {
        name: 'componentProps.overlayOpacity',
        label: '오버레이 불투명도',
        control: 'Slider',
        min: 0,
        max: 1,
        step: 0.1,
        defaultValue: 0.5,
        valueFormat: 'percentage' // 슬라이더 값을 퍼센트로 표시 (예: 0.5 -> 50%)
      }
    ]
  },
  {
    group: '텍스트 설정',
    icon: 'font',
    properties: [
      {
        name: 'componentProps.textColor',
        label: '텍스트 색상',
        control: 'ColorPicker',
        defaultValue: '#ffffff'
      },
      {
        name: 'componentProps.contentAlignment',
        label: '콘텐츠 정렬',
        control: 'Select',
        options: [
          { value: 'top', label: '상단' },
          { value: 'center', label: '중앙' },
          { value: 'bottom', label: '하단' }
        ],
        defaultValue: 'center'
      },
      {
        name: 'content',
        label: 'HTML 콘텐츠',
        control: 'RichEditor',
        defaultValue: '',
        richEditorSettings: {
          showPreview: true
        }
      }
    ]
  },
  {
    group: '크기 설정',
    icon: 'ruler',
    properties: [
      {
        name: 'componentProps.height',
        label: '높이 (px)',
        control: 'Number',
        min: 100,
        defaultValue: 500,
        deviceSpecific: true // 디바이스별로 다른 값 설정 가능
      }
    ]
  },
  {
    group: '외부 스킨',
    icon: 'palette',
    properties: [
      {
        name: 'componentProps.skin',
        label: '스킨 선택',
        control: SkinSelector,
        defaultValue: 'basic'
      }
    ]
  },
  {
    group: '디버그 설정',
    icon: 'bug',
    advanced: true, // 고급 설정으로 표시
    properties: [
      {
        name: 'debug',
        label: '디버그 모드',
        control: 'Checkbox',
        defaultValue: false
      }
    ]
  }
];

export default FixedBgTextProperties; 